module.exports = __webpack_public_path__ + "static/media/arrow-down-small-dec.f29c4850.svg";